
angular.module('theme.core.filters', ['ng'])